import styled, { css } from 'styled-components';

import { FlexBoxCol as Col, FlexBoxRow as Row } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { Desc, Text, Title, Wrapper as BannerWrapper } from '~/src/features/index/Banners/PromoBannersSection/PromoBanner/styled';

export const Wrapper = styled.section`
    display: block;
    width: 100%;
    margin-bottom: 56px;
`;

export const BannerRow = styled(Row)<{ notSingle: boolean }>`
    margin: 0;

    ${({ notSingle }) => notSingle && css`
        @media (max-width: 1359px) {
            margin: 0;
        }
    `};

    @media (min-width: ${wideBreakpoints.sDesktop}) {
        grid-gap: 1rem;
        flex-wrap: nowrap;
    }
`;

export const BannerCol = styled(Col)<{ isDoubleBanner: boolean }>`
    margin-bottom: 24px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    padding-left: 0;
    padding-right: 0;

    @media (min-width: ${wideBreakpoints.sDesktop}) {
        flex: auto;
        flex-basis: ${props => props.isDoubleBanner ? '50%' : '100%'};
        max-width: ${props => props.isDoubleBanner ? '50%' : '100%'};

        ${BannerWrapper} {
            ${props => props.isDoubleBanner && 'height: 330px'};
        }

        ${Title} {
            ${props => props.isDoubleBanner && FONTS.H2};
        }

        ${Text} {
            ${props => props.isDoubleBanner && FONTS.XS};
        }

        ${Desc} {
            ${props => props.isDoubleBanner && 'padding: 38px 0 38px 32px;'};
        }
    }

    @media (max-width: 1919px) {
        overflow: hidden;
    }
`;
